import { FolderIdentification } from './folder-identification';

export class FolderDeleteNotification {
    public viewId: number;
    public folderIdentifications: FolderIdentification[];

    public static fromJson(other: any): FolderDeleteNotification {
        const instance = new FolderDeleteNotification();
        instance.viewId = other.ViewId;
        instance.folderIdentifications = other.FolderIdentifications;
        return instance;
    }
}
